import { useCallback, useEffect, useState } from "react";
import { Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Grid, TextField, Button } from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { fetchBalanceSheet } from "../../../services/accounting";

export default function BalanceSheetPage() {
  useProtectedRoute();
  const { token } = useAuth();
  const [asOf, setAsOf] = useState<string>(new Date().toISOString().slice(0,10));
  const [data, setData] = useState<any>(null);

  const load = useCallback(async () => {
    try {
      const res = await fetchBalanceSheet(token!, { asOf });
      setData(res);
    } catch (e) { console.error(e); }
  }, [token, asOf]);

  useEffect(() => { if (token) load(); }, [token, load]);

  const section = (title: string, rows: Record<string, number>) => (
    <Paper className="mb-4">
      <Typography variant="h6" className="p-4 pb-0">{title}</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Account</TableCell>
            <TableCell align="right">Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(rows || {}).map(([acc, amt]) => (
            <TableRow key={acc}>
              <TableCell>{acc}</TableCell>
              <TableCell align="right">{Number(amt).toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );

  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight="bold" className="mb-4">Balance Sheet</Typography>
      <Grid container spacing={2} className="mb-3">
        <Grid item xs={12} sm={4}><TextField fullWidth type="date" label="As Of" value={asOf} onChange={e=>setAsOf(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
        <Grid item xs={12} sm={4}><Button fullWidth variant="contained" onClick={load}>Run</Button></Grid>
      </Grid>
      {data && (
        <>
          {section("Assets", data.assets)}
          {section("Liabilities", data.liabilities)}
          {section("Equity", data.equity)}
          <Paper className="p-4">
            <Typography variant="subtitle1">Totals</Typography>
            <Typography>Assets: {Number(data.totals.assets).toFixed(2)}</Typography>
            <Typography>Liabilities: {Number(data.totals.liabilities).toFixed(2)}</Typography>
            <Typography>Equity: {Number(data.totals.equity).toFixed(2)}</Typography>
          </Paper>
        </>
      )}
    </Box>
  );
}
